import { Component, Input, Output, EventEmitter } from '@angular/core';
import { environment } from '@/app/environments/environment';
import { CommonModule } from '@angular/common';
import { GetFileIconUtilityService } from '@/app/services/utility/get-file-icon-utility.service';
@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.css'],
})
export class GalleryComponent {
  @Input() isEdit!: boolean;
  @Input() uploadedFiles: any[] = [];
  @Output() onCLose: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSave: EventEmitter<any> = new EventEmitter<any>();
  base_path = environment.storageUrl;
  currentImageIndex = 0;
  selectedImage: string | null = null;
  selectedLocationImage: string | null = null;
  uploadedLocationFiles: { name: any; file: File; preview: string }[] = [];

  deleted_attachments: number[] = [];

  constructor(private getFileIconService: GetFileIconUtilityService) {}
  openPreview(index: number): void {
    this.currentImageIndex = index;
    this.selectedImage = this.uploadedFiles[index].preview;
  }

  closePreview(): void {
    this.selectedImage = null;
  }
  openPdf(imageSrc: string): void {
    window.open(imageSrc, '_blank');
  }
  removeFile(index: number, file: any) {
    this.uploadedFiles.splice(index, 1);

    if (this.isEdit) {
      this.deleted_attachments?.push(file?.id);
    }
  }
  prevLocationImage(): void {
    if (this.currentImageIndex > 0) {
      this.currentImageIndex--;
      this.selectedLocationImage =
        this.uploadedLocationFiles[this.currentImageIndex].preview;
    }
  }

  isImageFile(file: any): boolean {
    const imageExtensions = ['jpg', 'jpeg', 'svg', 'png', 'gif', 'bmp', 'webp'];
    let fileExtension: any;
    if (file?.file_path) {
      fileExtension = file?.file_path?.split('.').pop()?.toLowerCase();
    } else {
      fileExtension = file?.name?.split('.').pop()?.toLowerCase();
    }

    return imageExtensions.includes(fileExtension || '');
  }

  nextLocationImage(): void {
    if (this.currentImageIndex < this.uploadedLocationFiles.length - 1) {
      this.currentImageIndex++;
      this.selectedLocationImage =
        this.uploadedLocationFiles[this.currentImageIndex].preview;
    }
  }

  closeLocationPreview(): void {
    this.selectedLocationImage = null;
  }

  openLocationPreview(index: number): void {
    this.currentImageIndex = index;
    this.selectedLocationImage = this.uploadedLocationFiles[index].preview;
  }
  prevImage(): void {
    if (this.currentImageIndex > 0) {
      this.currentImageIndex--;
      this.selectedImage = this.uploadedFiles[this.currentImageIndex].preview;
    }
  }

  nextImage(): void {
    if (this.currentImageIndex < this.uploadedFiles.length - 1) {
      this.currentImageIndex++;
      this.selectedImage = this.uploadedFiles[this.currentImageIndex].preview;
    }
  }

  onFileUpload(event: any, location = false) {
    const files = event.target.files;
    const targetArray = location
      ? this.uploadedLocationFiles
      : this.uploadedFiles;
    for (const file of files) {
      const fileType = file.type;
      if (fileType.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          targetArray.push({
            file,
            name: file.name,
            preview: e.target.result,
          });
        };
        reader.readAsDataURL(file);
      } else {
        const pdfUrl = URL.createObjectURL(file);
        targetArray.push({
          file,
          name: file.name,
          preview: pdfUrl,
        });
      }
    }
  }

  splitFilename(filePath) {
    const pathSegments = filePath.split('/');
    return pathSegments[pathSegments.length - 1];
  }

  save() {
    const updatedAttachment: any = {
      deleted_attachments: this.deleted_attachments,
      uploadedFiles: this.uploadedFiles,
    };
    this.onSave.emit(updatedAttachment);
  }

  cancel() {
    this.onCLose.emit();
  }
  getFileIcon(file: any): string {
    return this.getFileIconService.getFileIcon({
      file: file.file,
      preview: file?.file_path, // Pass file_path as preview
      id: file.id,
      name: file.name,
    });
  }
}
